// npm packages
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
// hooks
import useBodyOverflow from '@/app/hooks/useBodyOverflow';
// components
import Button from '@/app/components/Button';
import Icon from '@/app/components/Icon';
import MenuSections from '@/app/components/Menu/MenuSections';
import SubMenuSections from '@/app/components/Menu/SubMenuSections';
import { cn } from '@/utils/cn';
import { handleCloseGlobalSearchModal } from '@/redux/reducers/search-reducer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPastOrderList } from '@/redux/thunk/orders-thunk';
import { setHasPastOrder } from '@/redux/reducers/orders-reducer';
import useWindowDimensions from '@/app/hooks/useWindowSize';
import { cancelOrderOption } from '@/constants/list';
import { updateIsMenuOpeStatus } from '@/redux/reducers/hamburger-menu-reducer';
import hamburgerVisibleRoutesData from './hamburgerVisibleRoutesData';
import { hamBurgerSections } from '../Menu/nav';
import SearchCartSpinMobile from './components/SearchCartSpinMobile';

function MobileHeaderMenu({ onSearchActive = () => {}, className = '' }) {
  const dispatch = useDispatch();
  const pathname = usePathname();
  const windowDimensions = useWindowDimensions();
  const { isMenuOpen, isSubMenuOpen, currentMenu } = useSelector(
    (state) => state.hamburgerMenu,
  );
  const { isSearchActive, isOpenGlobalSearchModal } = useSelector(
    (state) => state.search,
  );
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { hasPastOrder } = useSelector((state) => state.orders);
  const [hamBurgerSectionsInit, setHamBurgerSectionsInit] = useState([]);
  const [isVisibleMobileMenu, setIsVisibleMobileMenu] = useState(false);

  // const cancelOrderOption = {
  //   id: 'canceled',
  //   label: 'Cancellation',
  //   icon: 'cancellation-icon',
  //   url: '/my-orders?tab=canceled',
  // };

  useEffect(() => {
    setHamBurgerSectionsInit(JSON.parse(JSON.stringify(hamBurgerSections)));
  }, []);

  // CONDITONALLY ADD CANCELATION IF
  // 1. CANCEL DATA  EXIST
  // 2. FOR MOBILE SCREEN AND
  // 3. ONLY WHEN SUBMENU OPENED
  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(setHasPastOrder(false));
      setHamBurgerSectionsInit(JSON.parse(JSON.stringify(hamBurgerSections)));
    }
    if (
      isLoggedIn &&
      !hasPastOrder &&
      windowDimensions?.width < 1024 &&
      isMenuOpen
    ) {
      dispatch(fetchPastOrderList());
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const hamBurgerSectionsTemp = JSON.parse(JSON.stringify(hamBurgerSections));
    if (hasPastOrder) {
      const mySingerSection = hamBurgerSectionsTemp.find(
        (section) => section.id === 'my-singer',
      );
      if (mySingerSection) {
        const myOrders = mySingerSection.menu.find(
          (menu) => menu.id === 'my-orders',
        );
        if (myOrders?.subMenu?.length === 2) {
          myOrders.subMenu.push(cancelOrderOption);
        }
      }
    }
    setHamBurgerSectionsInit(JSON.parse(JSON.stringify(hamBurgerSectionsTemp)));
  }, [hasPastOrder]);

  useEffect(() => {
    if (!hamburgerVisibleRoutesData.includes(pathname)) {
      setIsVisibleMobileMenu(true);
    } else {
      setIsVisibleMobileMenu(false);
    }
  }, [pathname]);

  const renderHamburgerMenu = () => {
    if (!hamburgerVisibleRoutesData.includes(pathname)) {
      return (
        <Button
          type="link"
          className="!p-0"
          onClick={() => dispatch(updateIsMenuOpeStatus(!isMenuOpen))}
        >
          <Icon type="hamburger-menu" />
        </Button>
      );
    }
  };

  useBodyOverflow(isMenuOpen);

  return (
    <>
      <section
        className={cn(
          'mobile-header-menu lg:hidden w-full h-[56px] flex justify-between items-center gap-[24px] lg:gap-[10px] p-16 relative z-[520]',
        )}
      >
        {isOpenGlobalSearchModal ? (
          <Button
            type="link"
            className="!p-0 cursor-pointer w-fit"
            onClick={(e) => {
              e.stopPropagation();
              dispatch(handleCloseGlobalSearchModal(false));
            }}
          >
            <Icon type="arrow-left" color="#fff" className="size-[24px]" />
          </Button>
        ) : (
          renderHamburgerMenu()
        )}

        {!isOpenGlobalSearchModal ? (
          <Link prefetch={false} href="/" aria-label="Go to Homepage">
            <div
              className={cn(
                'header-logo',
                isVisibleMobileMenu &&
                  'absolute left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%]',
              )}
            >
              <Icon
                type="singer-logo"
                className="w-[116px] h-[22px] sm:h-full sm:w-[160px] md:w-[200px] max-w-full"
              />
            </div>
          </Link>
        ) : null}

        {/* search, cart and spin the wheel */}
        <SearchCartSpinMobile hideSpinTheWheel={isVisibleMobileMenu} />
      </section>

      {isMenuOpen ? (
        <MenuSections menuSections={hamBurgerSectionsInit} />
      ) : null}

      {isSubMenuOpen ? <SubMenuSections selectedMenu={currentMenu} /> : null}
    </>
  );
}

export default MobileHeaderMenu;
